import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    OrganizationAccount,
    OrganizationAccountFormType,
    OrganizationAccountRecordFormProps,
    OrganizationAccountStatus
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: OrganizationAccountRecordFormProps) => {

    const onSubmit = (values: OrganizationAccountFormType) => {
        handleSubmit(values as OrganizationAccount);
    };

    let initialValues = {
        organizationAccountStatus: OrganizationAccountStatus.ACTIVE,
    } as OrganizationAccountFormType;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<OrganizationAccountFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<OrganizationAccountFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
